<template>
  <div class="cr-personal-data">
    <div class="cr-container">
      <div class="cr-personal-data__section">
        <div class="cr-personal-data__title">
          Персональные данные
        </div>
        <div class="cr-personal-data__body">
          <dl class="cr-description-column">
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                Фамилия
              </dt>
              <dd class="cr-description-column__value">
                {{ user.last_name }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                Имя
              </dt>
              <dd class="cr-description-column__value">
                {{ user.name }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                Отчество
              </dt>
              <dd class="cr-description-column__value">
                {{ user.second_name }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                Телефон
              </dt>
              <dd class="cr-description-column__value">
                {{ user.phone }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                E-mail
              </dt>
              <dd class="cr-description-column__value">
                {{ user.email }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                Название заведения
              </dt>
              <dd class="cr-description-column__value">
                {{ user.bar_name }}
              </dd>
            </div>
          </dl>
        </div>
      </div>
      <div class="cr-personal-data__section">
        <div class="cr-personal-data__title">
          Юридическое лицо
        </div>
        <div class="cr-personal-data__body">
          <dl class="cr-description-column">
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                Наименование юридического лица
              </dt>
              <dd class="cr-description-column__value">
                {{ user.company }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                ИНН
              </dt>
              <dd class="cr-description-column__value">
                {{ user.inn }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                Юридический адрес
              </dt>
              <dd class="cr-description-column__value">
                {{ user.address }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                КПП
              </dt>
              <dd class="cr-description-column__value">
                {{ user.kpp }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                ОГРН
              </dt>
              <dd class="cr-description-column__value">
                {{ user.ogrn }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                ОКПО
              </dt>
              <dd class="cr-description-column__value">
                {{ user.okpo }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                ID ЕГАИС
              </dt>
              <dd class="cr-description-column__value">
                {{ user.egais }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                БИК
              </dt>
              <dd class="cr-description-column__value">
                {{ user.bik }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                Банк
              </dt>
              <dd class="cr-description-column__value">
                {{ user.bank }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                К/c
              </dt>
              <dd class="cr-description-column__value">
                {{ user.ks }}
              </dd>
            </div>
            <div class="cr-description-column__item">
              <dt class="cr-description-column__term">
                Р/c
              </dt>
              <dd class="cr-description-column__value">
                {{ user.rs }}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  data: () => ({

  }),
  computed: {
    ...mapGetters([
      'user',
    ]),
  }

}
</script>
